/* Team Carousel Section JavaScript */
(function () {
  'use strict';

  const wired = new WeakSet();

  function init(section) {
    if (wired.has(section)) return;
    const slider = section.querySelector('.team-carousel__slider-wrapper');
    const prevBtn = section.querySelector('.nav-btn-prev');
    const nextBtn = section.querySelector('.nav-btn-next');
    if (!slider || !prevBtn || !nextBtn) return;
    wired.add(section);

    const getScrollAmount = () => {
      const card = slider.querySelector('.team-card');
      const style = window.getComputedStyle(slider);
      const gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 0;
      const width = card ? card.offsetWidth : 0;
      return width > 0 ? width + gap : Math.max(slider.clientWidth * 0.8, 300);
    };

    /* RTL: a right-to-left scroll container puts the scroll origin on the RIGHT
       edge, so scrollLeft starts at 0 and grows NEGATIVE as content scrolls.
       The boundary tests below compare against 0 and `max`, and scrollBy's
       `left` is a physical delta, so both need the sign flipped. Each LTR
       expression is kept exactly as it was. */
    const isRTL = () => window.getComputedStyle(slider).direction === 'rtl';

    const updateButtons = () => {
      const max = slider.scrollWidth - slider.clientWidth - 1;
      const travelled = isRTL() ? -slider.scrollLeft : slider.scrollLeft;
      const atStart = travelled <= 0;
      const atEnd = max <= 0 || travelled >= max;
      prevBtn.setAttribute('aria-disabled', String(atStart));
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    };

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const amount = getScrollAmount();
      slider.scrollBy({ left: isRTL() ? amount : -amount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const amount = getScrollAmount();
      slider.scrollBy({ left: isRTL() ? -amount : amount, behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    window.addEventListener('load', updateButtons);
    updateButtons();
  }

  const boot = () => document.querySelectorAll('.team-carousel').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.team-carousel');
    if (section) init(section);
  });
})();
